import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
const CART_URL = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
interface PricingBlockProps {
  id: string;
  showValueTable?: boolean;
}
const valueItems = [{
  name: 'Código Sensorial TEA® — Sistema Completo (40 Herramientas)',
  value: '$49.999'
}, {
  name: 'Bono 01: Kit Exprés Sensorial',
  value: '$14.999'
}, {
  name: 'Bono 02: Ficha Perfil Editable',
  value: '$9.999'
}, {
  name: 'Bono 03: Guía Lúdica Terapéutica',
  value: '$12.999'
}, {
  name: 'Bono 04: Protocolo Anticrisis Express',
  value: '$14.999'
}, {
  name: 'Bono 05: Ruta Express 7 Días',
  value: '$9.999'
}];
export function PricingBlock({
  id,
  showValueTable = false
}: PricingBlockProps) {
  return <div id={id} className="bg-white text-brand-ink text-center py-16 px-6" data-id="element-131">
      <div className="max-w-2xl mx-auto" data-id="element-132">
        {showValueTable && <>
            <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-display font-extrabold tracking-[0.18em] uppercase text-brand-green mb-3 text-[18px]" data-id="element-133">
              Resumen de valor
            </motion.p>
            <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-display font-black md:text-4xl uppercase text-brand-ink mb-7 text-[36px]" data-id="element-134">
              Todo lo que Recibes Hoy
            </motion.h2>

            <motion.table initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full mb-8" data-id="element-135">
              <tbody data-id="element-136">
                {valueItems.map((item, index) => <motion.tr key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="border-b border-gray-200" data-id="element-137">
                    <td className="py-3.5 text-left text-gray-600 text-base" data-id="element-138">
                      {item.name}
                    </td>
                    <td className="py-3.5 text-right font-display font-bold text-gray-400 line-through" data-id="element-139">
                      {item.value}
                    </td>
                  </motion.tr>)}
                <motion.tr initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.9
            }} data-id="element-140">
                  <td className="py-5 text-left text-brand-ink font-bold text-lg" data-id="element-141">
                    VALOR TOTAL
                  </td>
                  <td className="py-5 text-right font-display font-bold text-brand-yellow-dark text-xl" data-id="element-142">
                    $112.994
                  </td>
                </motion.tr>
              </tbody>
            </motion.table>
          </>}

        {/* Scarcity Badge */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        type: 'spring',
        stiffness: 200
      }} className="inline-block bg-brand-red text-white font-display font-extrabold text-sm tracking-wider uppercase px-6 py-2 rounded-sm animate-pulse-btn mb-7" data-id="element-143">
          ⏰ OFERTA SOLO POR HOY — CIERRA SIN AVISO PREVIO
        </motion.div>

        {/* Price Before */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="font-display text-2xl text-gray-400 line-through mb-1" data-id="element-144">
          Valor real del sistema: $112.994
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="font-display font-bold text-xl text-brand-ink mb-2 uppercase tracking-wide" data-id="element-145">
          Precio de lanzamiento:
        </motion.p>

        {/* Price Now */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.5,
        y: 30
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        type: 'spring',
        stiffness: 150,
        damping: 15
      }} whileHover={{
        scale: 1.05,
        transition: {
          duration: 0.3
        }
      }} className="text-8xl md:text-9xl font-display font-black leading-none mb-2 bg-gradient-to-br from-brand-yellow to-brand-yellow-dark bg-clip-text text-transparent" data-id="element-146">
          <PriceDisplay amount={17.999} data-id="element-147" />
        </motion.div>

        {/* Price Note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="text-gray-400 uppercase tracking-wider font-semibold text-sm mb-8" data-id="element-148">
          Pago único · Sin cuotas · Acceso de por vida
        </motion.p>

        {/* CTA Button */}
        <motion.a initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} href="https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873" onClick={e => {
        e.preventDefault();
        const checkoutUrl = 'https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873';
        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            value: 17.999,
            currency: 'USD',
            content_name: 'Codigo Sensorial TEA',
            content_type: 'product'
          });
        }
        setTimeout(() => {
          window.location.href = checkoutUrl;
        }, 100);
      }} className="inline-block bg-brand-yellow text-brand-ink font-display font-black md:text-2xl uppercase tracking-wider py-5 rounded animate-pulse-btn hover:bg-brand-yellow-dark hover:scale-105 transition-all duration-150 shadow-lg text-[28px] px-[38px] text-center" data-id="element-149">
          QUIERO IMPLEMENTAR EL MÉTODO →
        </motion.a>

        {/* Trust Line */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="text-gray-400 text-sm mt-4 font-medium" data-id="element-150">
          🔒 Pago 100% seguro · Acceso inmediato · Garantía 60 días
        </motion.p>
      </div>
    </div>;
}